import { QRCodeSVG } from "qrcode.react";
import { MapPin, CalendarBlank } from "@phosphor-icons/react";
import { fmtDate, fmtTime, RISK } from "@/lib/api";

const gcal = (e) => {
  const f = (s) => new Date(s).toISOString().replace(/[-:]|\.\d{3}/g, "");
  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(e.title)}&dates=${f(e.start_at)}/${f(e.end_at)}&location=${encodeURIComponent((e.venue?.name || "") + " " + (e.venue?.address || ""))}`;
};

export const TicketCard = ({ r }) => {
  const e = r.event;
  const tz = e?.city?.timezone;
  const color = e?.price_tiers?.find((t) => t.code === r.tier_code)?.color || "#E0A21B";
  return (
    <div className="print-area flex flex-col overflow-hidden rounded-lg border border-[#0B1B33]/15 bg-white sm:flex-row" data-testid={`ticket-${r.ticket_code}`} style={{ breakInside: "avoid" }}>
      <div className="flex-1 p-5">
        <div className="flex items-center gap-2">
          <span className="h-5 w-1.5 rounded-full" style={{ background: color }} />
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#475569]">{r.tier_name} · Admit one</span>
        </div>
        <h3 className="mt-2 font-display text-2xl font-bold uppercase leading-tight">{e?.title}</h3>
        <div className="mt-1 text-lg font-semibold">{r.attendee_name}</div>
        <div className="mt-3 space-y-1 text-sm text-[#475569]">
          <div className="flex items-center gap-2"><CalendarBlank size={16} />{fmtDate(e?.start_at, tz, { weekday: "short" })} · {fmtTime(e?.start_at, tz)}</div>
          <div className="flex items-center gap-2"><MapPin size={16} />{e?.venue ? `${e.venue.name}, ${e.venue.address}` : `Venue being confirmed, ${e?.city?.name}. We'll email you.`}</div>
        </div>
        <div className="no-print mt-4 flex flex-wrap gap-2">
          {e && <a href={gcal(e)} target="_blank" rel="noreferrer" className="btn-outline px-3 py-1.5 text-xs" data-testid={`add-calendar-${r.ticket_code}`}>Add to calendar</a>}
        </div>
        <p className="mt-4 text-[10px] leading-snug text-[#475569]">{RISK}</p>
      </div>
      <div className="flex flex-col items-center justify-center gap-2 border-t border-dashed border-[#0B1B33]/20 bg-[#F4F6FA] p-5 sm:border-l sm:border-t-0">
        <QRCodeSVG value={r.ticket_code} size={128} fgColor="#0B1B33" />
        <span className="font-mono-num text-sm font-semibold" data-testid={`ticket-code-${r.ticket_code}`}>{r.ticket_code}</span>
        <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold uppercase ${r.status === "checked_in" ? "bg-[#1E8E5A] text-white" : r.status === "cancelled" ? "bg-[#C8382E] text-white" : "bg-[#0B1B33] text-white"}`}>{r.status.replace("_", " ")}</span>
      </div>
    </div>
  );
};
